import { isConsideredEmptyString, isDefined } from "helpers/predicates";
import {
  levelIdLabelMap,
  levelIdColorMap,
  LEVEL_FALLBACK_TYPE,
} from "constants/default-values";

const getLevelType = (label) => {  
  var index;
  if (levelIdLabelMap['1'] === label) index = '1';
  if (levelIdLabelMap['2']=== label) index = '2';
  if (levelIdLabelMap['3'] === label) index = '3';
  // return false if no element found, or index of the element
  return index === undefined ? 99 : index;
}
  


const getLevel = (level) => {  
  const label = isConsideredEmptyString(level.toString()) ? LEVEL_FALLBACK_TYPE : String(level);
  const id = getLevelType(label);
  const color = levelIdColorMap[id];

  return {
    id,
    label,
    color,
  };
};


const getNormalizedUbung = (currentUbung, incrementor) => {
  return {
    incrementor: incrementor,
    index: Number(currentUbung.field_ubungsnummer),
    duration: 0,
    categoryName: currentUbung.field_rubrikLabel,
    durationSeconds: 0,
    name: currentUbung.title,
    title: currentUbung.title,
    url: currentUbung.embedUrl ,
    level: getLevel(currentUbung.field_level),
    isFreemium: 0,
    showFreemium: 0,
    hasExercise: 0,
    pageImg: [],
  };
};

const getGroupedByCategory = (permissions) => {
  if (!isDefined(permissions) || !isDefined(permissions.ubungen)) {
    return [];
  }

  return permissions.ubungen.reduce((accumulator, currentUbung, index) => {
    const currentCategory = currentUbung.field_rubrikId.trim();
    const currentCategoryLabel = currentUbung.field_rubrikLabel.trim();
    const groupedUbungen = accumulator.filter(
      (ubung) => ubung.rubrik === currentCategory
    );

    const normalizedUbung = getNormalizedUbung(currentUbung, index);

    if (!groupedUbungen.length) {
      accumulator.push({
        category: currentCategory,
        categoryLabel: currentCategoryLabel,
        nid: Number(currentUbung.nid),
        ubung: [normalizedUbung],
      });
    } else {
      groupedUbungen[0].ubungen.push(normalizedUbung);
    }
    return accumulator;
  }, []);
};

const getIssueArray = (issue) => {
  const year = issue.slice(0, 4);
  const nr = issue.slice(4);
  return { year, nr };
};

export const normalizer = (permissions) => {
  const groupedByCategory = getGroupedByCategory(permissions);
  return {
    ...permissions,
    groupedByCategory: groupedByCategory,
    //tracks: permissions.tracks.map((track, i) => getNormalizedUbung(track, i)),
    ubungen: permissions.ubungen.map((ubung, i) => getNormalizedUbung(ubung, i)),
    coverImg: permissions?.field_cover,
    title: permissions?.field_ausgabe_title,
    field_totalexercises: permissions?.field_totalexercises,
    issue: getIssueArray(permissions.field_issue_no),
    logo: permissions?.logo,
  };
};
